import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { catchError} from "rxjs";
import { ToastService } from "../services/toast.service";
import { SnackbarService } from "../services/snackbar.service";
import { AuthService } from "../services/auth.service";
import { NotificationData, ObjectUtils, Utils } from "fakturnia-shared";
import { ErrorUtils } from "../utils/error-utils";
import { DialogService } from "../services/dialog.service";
import { Router } from "@angular/router";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  private readonly _toastService: ToastService = inject(ToastService)
  private readonly _snackbarService: SnackbarService = inject(SnackbarService)
  private readonly _authService: AuthService = inject(AuthService)
  private readonly _router: Router = inject(Router)
  private readonly _dialogService: DialogService = inject(DialogService)


  intercept(request: HttpRequest<any>, next: HttpHandler | any): any {
    return next.handle(request)
      .pipe(
        catchError(async (response: HttpErrorResponse | any) => {
          if (response.status === 0 && request.method != 'GET') {
            this._snackbarService.showSnackBar('Nie udało się nawiązać połączenia z serwerem.', "warning", 4000)
            throw new HttpErrorResponse(response);
          }
          
          else if (response.status === 500 || response.status == 400 || response.status == 404) {
            this._toastService.showToast(new NotificationData({
              title: 'Wystąpił błąd.',
              message: 'Nie udało się prawidłowo przetworzyć Twojego żądania. Zgłoś problem administratorowi.',
              status: 'danger',
              timeToClose: 0
            }))
          }

          else if (response.status === 401) {
            
            // Must propagate error to successfully logout
            if (response?.url?.includes('logout')) {
              throw new HttpErrorResponse(response);
            }
            if (response?.url?.includes('synchronize')) {
              throw new HttpErrorResponse(response);
            }

            const errorMessage = ObjectUtils.getNestedValue(response, "error.message")

            // Disable to logout if it is a expired token
            if (errorMessage == 'TOKEN_EXPIRED') return next.handle(request)
            
            this._authService.clearSession()
            this._snackbarService.showSnackBar('Zostałeś wylogowany. Twoja sesja wygasła', 'info')
            this._router.navigate(['logowanie']);

          }

          // Forbidden
          else if (response.status === 403) {
            
            // Must propagate error to successfully logout
            if (response?.url?.includes('logout')) {
              throw new HttpErrorResponse(response);
            }

            const errorMessage = ObjectUtils.getNestedValue(response, "error.message")

            // Obsługa przekroczenia limitu dokumentów
            if (errorMessage === 'DOCUMENT_LIMIT_EXCEEDED') {
              this._dialogService.showDocumentLimitExceededDialog()
              throw new HttpErrorResponse(response);
            }
            
            // Domyślnie - wyloguj użytkownika
            this._authService.clearSession()
            this._snackbarService.showSnackBar('Zostałeś wylogowany. Twoja sesja wygasła', 'info')
            this._router.navigate(['logowanie']);

          }

          else if (response.status === 422) {
            const responseErrors = response.error?.errors;
            // Obsługa prostych błędów walidacji biznesowej (string[])
            if (Array.isArray(responseErrors) && responseErrors.length > 0 && typeof responseErrors[0] === 'string') {
              const formattedErrors = [{ field: 'Walidacja', errors: responseErrors as string[] }];
              this._dialogService.showFormErrorsDialog(formattedErrors)
              this._snackbarService.showSnackBar(responseErrors[0], 'warning', 4000)
            } else {
              // Obsługa błędów class-validator (zagnieżdżona struktura)
              const errors: any = ErrorUtils.extractErrors(response.error)
              this._dialogService.showFormErrorsDialog(errors)
              this._snackbarService.showSnackBar('Popraw błędy w formularzu.', 'warning', 4000)
            }
          }

          // Synchronization needs error handling
          throw new HttpErrorResponse(response);
        })
      )
  }
}


export const ErrorInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: ErrorInterceptor,
  multi: true
}




